export default "__VITE_ASSET__Ao$5fwwZ__"